class AuditReportController {
    constructor($routeParams, $browser, $window, $location, $uibModal, toastr, moment, UserDetailsApi, ngProgressFactory, SettingsService, ReportServiceApi, ReportUtilityServiceApi, ReportUtils) {
        // Use $onInit to call init
        this.$onInit = () => {
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                defaultSort: false,
                userDetails: null,
                showFilters: true,
                views: [],
                selectedView: {},
                selectedTable: '',
                selectedType: '',
                selectedCommitter: '',
                selectedQuantity: '1000',
                reportRequest: {
                    UserId: -1,
                    ByUserId: -1,
                    Table: '',
                    Type: '',
                    ByUser: '',
                    FromDate: null,
                    ToDate: null,
                    RowQuantity: 1000,
                    autoDisplay: false,
                    Value: '',
                    Field: ''
                },
                DateFormats: {},
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                showReport: false,
                selectedAffectedUser: {}
            };
            this.data = {
                auditReports: [],
                affectedUsers: [],
                byUsers: [],
                types: [],
                lookups: {}
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.auditReport = {
                Id: 0,
                Name: '',
                Description: 'Audit Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.datePicker = {
                date: { startDate: null, endDate: null }
            };
            this.rowCount = 0;
            this.columnDefs = [
                {
                    headerName: 'Id',
                    field: 'AuditID',
                    width: 70,
                    minWidth: 70,
                    hide: true
                },
                {
                    headerName: 'Row ID',
                    field: 'RowIdentifier',
                    width: 100,
                    minWidth: 100,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Action',
                    field: 'ChangeType',
                    width: 70,
                    minWidth: 70,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Change Date',
                    field: 'ChangeDate',
                    width: 150,
                    minWidth: 150,
                    cellRenderer: this.loginTimeCellRenderer,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Table',
                    field: 'TableName',
                    minWidth: 100
                },
                {
                    headerName: 'Field',
                    field: 'FieldName',
                    minWidth: 100
                },
                {
                    headerName: 'By UserId',
                    field: 'ByUserId',
                    width: 120,
                    minWidth: 120,
                    hide: true
                },
                {
                    headerName: 'By User',
                    field: 'ByUser',
                    minWidth: 80,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'User Reference',
                    field: 'UserReference',
                    minWidth: 130,
                    suppressSizeToFit: true,
                    hide: true
                },
                {
                    headerName: 'Old Value',
                    field: 'OldValue',
                    minWidth: 120
                },
                {
                    headerName: 'New Value',
                    field: 'NewValue',
                    minWidth: 120
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.traceProgress.start();
            this.SettingsService.getSettings().then(response => {
                let appSettings = response.data;
                // Decide if User Reference is to be shown
                this.showUserRef(appSettings.UseSingleSignOn);
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.datePicker.options = {
                    opens: 'right',
                    showCustomRangeLabel: false,
                    alwaysShowCalendars: true,
                    format: this.state.DateFormats.DateFormat,
                    locale: {
                        cancelLabel: 'Cancel'
                    },
                    maxDate: this.moment(),
                    separator: ' to ',
                    eventHandlers: {
                        'apply.daterangepicker': (ev, picker) => {
                            this.selectDateRange(ev, picker);
                        },
                        'cancel.daterangepicker': (ev, picker) => {
                            this.clearDates();
                        }
                    },
                    ranges: {
                        Today: [this.moment(), this.moment()],
                        Yesterday: [
                            this.moment().subtract(1, 'days'),
                            this.moment().subtract(1, 'days')
                        ],
                        'Last 7 Days': [
                            this.moment().subtract(6, 'days'),
                            this.moment()
                        ],
                        'Last 30 Days': [
                            this.moment().subtract(29, 'days'),
                            this.moment()
                        ],
                        'This Month': [
                            this.moment().startOf('month'),
                            this.moment().endOf('month')
                        ],
                        'Last Month': [
                            this.moment()
                                .subtract(1, 'month')
                                .startOf('month'),
                            this.moment()
                                .subtract(1, 'month')
                                .endOf('month')
                        ],
                        'Last 3 Months': [
                            this.moment()
                                .subtract(3, 'month')
                                .startOf('month'),
                            this.moment()
                                .subtract(1, 'month')
                                .endOf('month')
                        ]
                    }
                };
                this.datePicker.date = {
                    startDate: this.moment().subtract(1, 'days'),
                    endDate: this.moment()
                };
            });
            // Get our dropdown boxes data
            this.ReportServiceApi.getAuditLookups().then((lookups) => {
                this.traceProgress.complete();
                this.data.lookups = lookups.data;
                let all = { Id: 0, Name: 'All types' };
                // @ts-ignore lodash typings missins concat
                this.data.lookups.Types = _.concat(all, lookups.data.Types);
                all = { Id: 0, Name: 'All committers' };
                // @ts-ignore lodash typings missins concat
                this.data.lookups.Committers = _.concat(all, lookups.data.Committers);
                all = { Id: 0, Name: 'All fields' };
                // @ts-ignore lodash typings missins concat
                this.data.lookups.Fields = _.concat(all, lookups.data.Fields);
                all = { Id: 0, Name: 'All tables' };
                // @ts-ignore lodash typings missins concat
                this.data.lookups.Tables = _.concat(all, lookups.data.Tables);
                all = { Id: 0, Name: 'All affected users' };
                // @ts-ignore lodash typings missins concat
                this.data.lookups.AffectedUsers = _.concat(all, lookups.data.AffectedUsers);
                this.state.selectedTable = this.data.lookups.Tables[0].Name;
                this.state.selectedType = this.data.lookups.Types[0].Name;
                this.state.selectedCommitter = this.data.lookups.Committers[0].Name;
                this.state.selectedAffectedUser = this.data.lookups.AffectedUsers[0];
            });
            this.UserDetailsApi.get().then((data) => {
                this.traceProgress.complete();
                this.state.userDetails = data; // setup our user details
                this.state.reportRequest.FromDate = null;
                this.state.reportRequest.ToDate = null;
                this.setupViews();
                let all = this.createViewJSON(0, 'All records', null, null, null, null, null, null, null);
                // @ts-ignore : lodash typings missing concat
                this.state.views = _.concat(all, this.state.views);
                this.state.selectedView = this.state.views[0];
                // Default to first selected view (24 hours filter)
                let view = this.state.selectedView.reportRequest;
                for (let attrname in view) {
                    let x = attrname;
                    this.state.reportRequest[x] = view[attrname];
                }
                this.state.selectedQuantity = '1000';
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('AuditReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.auditReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.loginTimeCellRenderer = (row) => {
            return this.timeCellRenderer(row.data.ChangeDate);
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.timeCellRenderer = (date) => {
            if (date === undefined) {
                return '';
            }
            let time = [
                '<span>',
                this.moment(new Date(date)).format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            return time;
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.defaultSort = () => {
            this.gridOptions.columnApi.applyColumnState({
                state: [{ colId: 'ChangeDate', sort: 'desc' }]
            });
        };
        this.selectType = () => {
            if (_.isNil(this.state.selectedType)) {
                this.state.selectedType = 'All types';
            }
            if (this.state.selectedType === 'All types') {
                this.state.reportRequest.Type = '';
            }
            else {
                this.state.reportRequest.Type = this.state.selectedType;
            }
        };
        this.selectCommitter = () => {
            if (_.isNil(this.state.selectedCommitter)) {
                this.state.selectedCommitter = 'All committers';
            }
            if (this.state.selectedCommitter === 'All committers') {
                this.state.reportRequest.ByUser = '';
            }
            else {
                this.state.reportRequest.ByUser = this.state.selectedCommitter;
            }
        };
        this.selectAffectedUser = () => {
            if (_.isNil(this.state.selectedAffectedUser)) {
                this.state.selectedAffectedUser = {
                    Id: 0,
                    Name: 'All affected users'
                };
            }
            this.state.reportRequest.UserId = this.state.selectedAffectedUser.Id;
        };
        this.selectTable = () => {
            if (_.isNil(this.state.selectedTable)) {
                this.state.selectedTable = 'All tables';
                this.state.reportRequest.Value = '';
            }
            if (this.state.selectedTable === 'All tables') {
                this.state.reportRequest.Table = '';
            }
            else {
                this.state.reportRequest.Table = this.state.selectedTable;
            }
            // getReport();
        };
        this.selectValue = () => {
            // getReport();
        };
        this.clearValue = () => {
            this.state.reportRequest.Value = '';
        };
        this.selectQuantity = () => {
            if (_.isNil(this.state.selectedQuantity)) {
                this.state.selectedQuantity = '1000';
            }
            this.state.reportRequest.RowQuantity = parseInt(this.state.selectedQuantity);
        };
        this.selectView = () => {
            if (_.isNil(this.state.selectedView)) {
                this.state.selectedView = this.state.views[0];
            }
            let view = this.state.selectedView.reportRequest;
            if (view.name !== 'Date Range') {
                this.clearDates();
            }
            if (view.name !== 'By Type') {
                this.state.selectedType = this.data.lookups.Types[0].Name;
                this.state.reportRequest.Type = '';
            }
            if (view.name !== 'By Committing User') {
                this.state.selectedCommitter = this.data.lookups.Committers[0].Name;
                if (this.state.selectedCommitter === 'All committers') {
                    this.state.reportRequest.ByUser = '';
                }
                else {
                    this.state.reportRequest.ByUser = this.state.selectedCommitter;
                }
            }
            if (view.name !== 'By Affected User') {
                this.state.selectedAffectedUser = this.data.lookups.AffectedUsers[0];
                this.state.reportRequest.UserId = this.state.selectedAffectedUser.Id;
            }
        };
        this.getAuditRows = () => {
            this.getReport();
        };
        this.getReport = () => {
            this.traceProgress.start();
            this.ReportServiceApi.getArchiveAuditReport(this.state.reportRequest).then((response) => {
                this.traceProgress.complete();
                this.data.auditReports = response.data;
                this.gridOptions.api.setRowData(this.data.auditReports);
                this.gridOptions.api.redrawRows();
                if (this.state.defaultSort === true) {
                    this.defaultSort();
                }
                return;
            });
        };
        this.showUserRef = (isSSO) => {
            let idx = 0;
            for (idx = 0; idx < this.columnDefs.length; idx++) {
                if ((this.columnDefs[idx].field === 'UserReference') && (isSSO)) {
                    this.columnDefs[idx].hide = false;
                }
            }
        };
        this.createViewJSON = (id, name, userId, byUserId, table, type, ByUser, fromDate, toDate) => {
            let defaultValues = {
                id: null,
                name: null,
                reportRequest: {
                    UserId: -1,
                    ByUserId: -1,
                    Type: '',
                    ByUser: '',
                    FromDate: null,
                    ToDate: null,
                    Table: '',
                    RowQuantity: 0,
                    Value: '',
                    Field: ''
                }
            };
            defaultValues.id = id;
            defaultValues.name = name;
            if (userId !== null) {
                defaultValues.reportRequest.UserId = userId;
            }
            if (byUserId !== null) {
                defaultValues.reportRequest.ByUserId = byUserId;
            }
            if (type !== null) {
                defaultValues.reportRequest.Type = type;
            }
            if (ByUser !== null) {
                defaultValues.reportRequest.ByUser = ByUser;
            }
            if (fromDate !== null) {
                defaultValues.reportRequest.FromDate = fromDate;
            }
            if (toDate !== null) {
                defaultValues.reportRequest.ToDate = toDate;
            }
            return defaultValues;
        };
        this.setupViews = () => {
            let id = 1;
            // var toDate = this.moment();
            // var fromDate = this.moment().subtract(1, 'days');
            // var view = createViewJSON(id, 'Last 24 hours', null, null, null, null, null, fromDate, toDate, true);
            // this.state.views.push(view);
            // //Date Filters
            // id++;
            // toDate = this.moment();
            // fromDate = this.moment().subtract(2, 'days');
            // view = createViewJSON(id, 'Last 48 hours', null, null, null, null, null, fromDate, toDate, true);
            // this.state.views.push(view);
            // id++;
            // toDate = this.moment();
            // fromDate = this.moment().subtract(3, 'days');
            // view = createViewJSON(id, 'Last 72 hours', null, null, null, null, null, fromDate, toDate, true);
            // this.state.views.push(view);
            // id++;
            let view = this.createViewJSON(id, 'Date Range', null, null, null, null, null, null, null);
            this.state.views.push(view);
            // Non Date Based Filters
            id++;
            view = this.createViewJSON(id, 'By Type', null, null, null, null, null, null, null);
            this.state.views.push(view);
            id++;
            view = this.createViewJSON(id, 'By Committing User', null, null, null, null, null, null, null);
            this.state.views.push(view);
            // id++;
            // view = createViewJSON(id, 'By Affected User', null, null, null, null, null, null, null, true);
            // this.state.views.push(view);
        };
        this.exportCsv = () => {
            let titleLabel = this.auditReport.Description + '.csv';
            const title = [titleLabel].join('');
            const reportName = this.ReportService.addDateToTitle(title);
            const params = {
                allColumns: false,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.selectDateRange = (ev, picker) => {
            this.state.reportRequest.FromDate = this.moment(this.datePicker.date.startDate)
                .utc()
                .toDate();
            this.state.reportRequest.ToDate = this.moment(this.datePicker.date.endDate)
                .utc()
                .toDate();
        };
        this.clearDates = () => {
            this.datePicker.date = { startDate: null, endDate: null };
            this.state.reportRequest.FromDate = this.datePicker.date.startDate;
            this.state.reportRequest.ToDate = this.datePicker.date.startDate;
        };
        this.ReportService = ReportUtilityServiceApi;
        this.routeParams = $routeParams;
        this.browser = $browser;
        this.window = $window;
        this.location = $location;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.ngProgressFactory = ngProgressFactory;
        this.SettingsService = SettingsService;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('auditReport', {
    templateUrl: 'Scripts/App/partials/Reports/audit-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: AuditReportController
});
